import { createStyles } from 'antd-style';
import { Access, useAccess } from '@umijs/max';
import React, { useState } from 'react';
import DutyModal from './DutyModal';

const useStyles = createStyles(({ token }) => ({
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '100%',
    padding: '0 12px',
    fontSize: 14,
    color: token.colorTextSecondary,
    cursor: 'pointer',
    borderRadius: token.borderRadius,
    transition: 'all 0.2s',
    '&:hover': {
      color: token.colorPrimary,
      backgroundColor: token.colorBgTextHover,
    },
  },
}));

const DutyButton: React.FC = () => {
  const access = useAccess();
  const { styles } = useStyles();
  const [open, setOpen] = useState(false);

  return (
    <Access accessible={access.hasPermission('global:duty')}>
      <span className={styles.trigger} onClick={() => setOpen(true)}>
        我要值班
      </span>
      <DutyModal open={open} onOpenChange={setOpen} />
    </Access>
  );
};

export default DutyButton;
